import React, { useContext, useState } from "react";
import { Button, Form, Input, Typography } from "antd";
import AuthContext from "../../../context/AuthContext";
import Styles from "./Login.module.css";

const { Paragraph, Title } = Typography;

const MicrosoftLogo = () => (
  <svg aria-hidden="true" width="18" height="18" viewBox="0 0 21 21" focusable="false">
    <rect x="1" y="1" width="9" height="9" fill="#f25022" />
    <rect x="11" y="1" width="9" height="9" fill="#7fba00" />
    <rect x="1" y="11" width="9" height="9" fill="#00a4ef" />
    <rect x="11" y="11" width="9" height="9" fill="#ffb900" />
  </svg>
);

export const LoginForm = () => {
  const [isMicrosoftLoading, setIsMicrosoftLoading] = useState(false);
  const {
    username,
    password,
    onChangeUsername,
    onChangePassword,
    handleLogin,
    openCloseModalResetPassword,
  } = useContext(AuthContext);

  return (
    <section className={Styles.panel} aria-labelledby="login-title">
      <div className={Styles.intro}>
        <span className={Styles.eyebrow}>OSI Support</span>
        <Title id="login-title" level={1} className={Styles.title}>Welcome back</Title>
        <Paragraph className={Styles.description}>
          Sign in to manage projects, track requests, and get help from the OSI team.
        </Paragraph>
      </div>

      <Form layout="vertical" onFinish={handleLogin} requiredMark="optional" className={Styles.form}>
        <Form.Item
          label="Username"
          name="username"
          rules={[{ required: true, message: "Enter your username" }]}
        >
          <Input
            autoComplete="username"
            name="username"
            placeholder="Enter your username…"
            size="large"
            spellCheck={false}
            value={username}
            onChange={(event) => onChangeUsername(event.target.value)}
          />
        </Form.Item>
        <Form.Item
          label="Password"
          name="password"
          rules={[{ required: true, message: "Enter your password" }]}
        >
          <Input.Password
            autoComplete="current-password"
            name="password"
            placeholder="Enter your password…"
            size="large"
            value={password}
            onChange={(event) => onChangePassword(event.target.value)}
          />
        </Form.Item>
        <Button
          type="primary"
          htmlType="submit"
          size="large"
          className={Styles.login_form__signin}
        >
          Sign in
        </Button>
      </Form>

      <div className={Styles.divider} role="separator" aria-label="or">
        <span>or</span>
      </div>
      <Button
        size="large"
        icon={<MicrosoftLogo />}
        loading={isMicrosoftLoading}
        className={Styles.microsoft}
        onClick={() => {
          setIsMicrosoftLoading(true);
          window.location.href = `${process.env.REACT_APP_DEV_API}/auth/microsoft`;
        }}
      >
        Sign in with Microsoft
      </Button>

      <Button
        type="link"
        className={Styles.forgot}
        onClick={() => openCloseModalResetPassword(true)}
      >
        Forgot your password?
      </Button>
    </section>
  );
};
